import { createSlice } from '@reduxjs/toolkit';

export const operationSlice = createSlice({
  name: 'operation',
  initialState: {
    id: null,
    loading: false,
    capture_configurations: {}
  },
  reducers: {
    setLoadingState: (state) => { state.loading=true },
    loadOperation: (state, action) => {
      state.id = action.payload.id;
      state.operation = action.payload.operation;
      state.capture_configurations = action.payload.capture_configurations!=null ? action.payload.capture_configurations : {};
      state.loading = false;
    }
  },
  selectors: {
    selectId: (state) => state.id,
    selectLoading: (state) => state.loading,
    selectOperation: (state) => state.operation,
    selectCaptureConfigurations: (state) => state.capture_configurations,
    selectError: (state) => state.error
  }
});

export const { setLoadingState, loadOperation } = operationSlice.actions;

export const { selectId, selectLoading, selectOperation, selectCaptureConfigurations, selectError } = operationSlice.selectors;

export default operationSlice.reducer;
